import { CircleAlertIcon } from "lucide-react";
import { cn } from "@punchup/utils/cn";

export default function ShowsNearbyEmptyShows({
  className = "pt-24",
}: {
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center h-full gap-3",
        className
      )}
    >
      <div className="flex flex-row gap-2 items-center justify-center">
        <CircleAlertIcon height={20} width={20} />
        <h3 className="text-lg text-primary-blue font-sans normal-case">
          No Shows Found
        </h3>
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-sm text-secondary-blue text-center">
          Try adjusting your filters or location to find what you&apos;re
          looking for.
        </p>
        <p className="text-sm text-secondary-blue text-center">
          New shows are added all the time, so check back soon!
        </p>
      </div>
    </div>
  );
}
